<template>
	<v-row
		justify = "center"
		align   = "center"
	>
		<v-col
			xl 	 = "12"
			lg 	 = "12"
			md 	 = "12"
			sm 	 = "12"
			xs 	 = "12"
			cols = "12"
		>
			<v-card outlined>
				<v-card-title
					class = "grey secondary pa-0 body- white--text justify-center"
				>
					<v-icon
						small
						color  = "primary"
						v-text = "'mdi-monitor'" 
						class  = "mx-2"
					></v-icon>

					<span
						v-text = "$ml.get(head.title)"
					></span>
					<!-- <v-chip 
						small 
						color  = "success"
						class  = "mx-2 text-uppercase"
						v-show = "head.title1"
					>  {{ head.title1 }} </v-chip> -->


					<!-- <v-spacer></v-spacer> -->
					
					<v-icon 
						small 
						color 	= "white"
						class 	= "ml-1"
						@click 	= "$router.back()"
						v-show  = "false" 
					>
						mdi-arrow-left-circle
					</v-icon>
					
				
				</v-card-title>
				<v-card-text
					class = "pa-1"
				>
					<v-row>
						
						<v-col 
							cols 	= "4"
							v-show 	= "show.add"
						>
							<v-card 
								outlined
								class = "mt-2"
							>
								<v-card-title
									class = "pa-0 pl-2 primary body-2 white--text"
								>
									<span
									>
										{{ sub_title }}										
									</span>
									
									<v-spacer></v-spacer>

								</v-card-title>	
								<v-card-text
									class = "pa-1 "
								>
								<v-row
									no-gutters
									justify = "center"
									align 	= "center"
								>	
									<template
										v-for = "(item_field, idx_field) of info_fields "
										
									>			
									<!-- v-if  = "item_field.enable"			 -->
										<v-col 
											cols = "11"
											:key = "idx_field"
										>
											<v-text-field
												dense
												outlined
												hide-details
												v-if 		 = "item_field.type == 'text' || item_field.type == 'number'"
												v-model 	 = "info[item_field.key]"
												:label  	 = "$ml.get(item_field.text)"
												:type 		 = "item_field.type"
												class 		 = "mt-2"
												v-show 		 = "item_field.enable"
												:placeholder = "item_field.placeholder ? item_field.placeholder : ''"
												@click 		 = "$Helper.keyboard_is_active(item_field.key, ID_notification, 'obj', 'info', info[item_field.key])"	
											></v-text-field>
												<!-- @input 	= "v => { v = input[item_field.key] }" -->
												<!-- :disabled = "item_field.enable"								 -->
												<!-- @input  = "v => { info[item_field.key] = v.toUpperCase()}"		 -->
											
											<v-select
												dense
												outlined
												hide-details
												v-if 		= "item_field.type == 'select'"
												:label 		= "$ml.get(item_field.text)"
												v-model 	= "info[item_field.key]"
												:items 		= "render_listeds(item_field.list)"
												:item-text  = "item_field.item_text"
												:item-value = "item_field.value" 
												class 		= "my-2"
												@input 		= "render_input(item_field.key)"
											>
												<!-- return-object -->
												<!-- multiple -->
												<template v-slot:selection="{ item, index }">
											        <v-chip x-small 
											        	v-if = "index < 3">
											          <span>{{ item }}</span>
											        </v-chip>
											        <span
											          v-if  = "index == 4"
											          class = "grey--text caption"
											        >
											          (+{{ info[item_field.key].length - 3 }} others)
											        </span>
											      </template>
											</v-select>
										</v-col>
									</template>
								</v-row>

								</v-card-text>
								<v-divider></v-divider>
								<v-card-actions>
									<v-spacer></v-spacer>

									<v-progress-circular
								      	indeterminate
								      	color  = "primary"
								      	v-show = "show_progress"
								    	:size  = "20"
								    	:width = "4"
								    ></v-progress-circular>

									<v-btn
										x-small
										v-show 		= "!show_progress"
										color  		= "primary"										
										@click 		= "actions(btn_action)"
										:disabled 	= "!required_info"
									>
										{{ $ml.get(btn_action) }}
									</v-btn>
									<!-- <v-btn
										x-small
										color 	  =  "error"
										:disabled = "btn_action == 'update' ? false : true"
										v-text    = "$ml.get('delete')"						
										@click    = "actions('confirm_delete')"
									></v-btn> -->
								</v-card-actions>
							</v-card>
						</v-col>
						<v-col

						>

							<v-toolbar
					    		dense
					    		height = "25"
					    		class  = "secondary white--text mt-2"
					    	>
					    		<v-icon
									small
									color = "white"
									class = "mr-1"
								>
									mdi-view-list
								</v-icon>
					    		<v-toolbar-title 
					    			class = "body-2"
					    		>
					    			{{ $ml.get(head.table)}}
					    		</v-toolbar-title>
					    			<v-spacer></v-spacer>
					    			<v-btn
					    				x-small
					    				fab
					    				height  = "25"
					    				:color  = "!show.add ? 'primary' : 'error'"
					    				@click  = "actions('show')"
					    				v-show  = "show.add_workspace"
					    			>
					    				<v-icon>

					    					{{ !show.add ? 'mdi-plus' : 'mdi-close' }} 
					    				</v-icon>
					    			</v-btn>
					    	</v-toolbar>
							
							<v-divider></v-divider>

							<v-data-table
								dense
							    fixed-body
							    fixed-header
								class 				 = "elevation-5"
								:items 				 = "render_list"
								:headers 			 = "header_table"
								:options.sync 		 = "options"
							   	:server-items-length = "total"
							   	loading-text 		 = "Loading... Please wait"
							   	:loading 			 = "loading"
							    item-key 			 = "id"
							    :height  			 = "layout_height + 'px'"
							   	:footer-props  		 = "{
							   		showFirstLastPage 	: true,
							   		itemsPerPageOptions : [15, 30],
							   		showCurrentPage 	: true,
							   		itemsPerPageText 	: ''
							   	}"
							   	
							>
							    <!-- rowsPerPageText: [30] -->
								<template v-slot:item.actions="{ item }" >
									<!-- <v-btn
										x-small
										color  = "primary"
										@click = "actions('edit', item)"
										v-show = "show.edit_workspace"
									>
										<v-icon
											x-small
											
										>
											mdi-pencil
										</v-icon>
									</v-btn> -->	
									
									<v-btn
										x-small
										color  = "error"
										v-show = "item.manager_id != 'my_computer' && show.delete_workspace"
										@click = "actions('confirm_delete', item)"
										
									>
										<v-icon
											x-small
											
										>
											mdi-delete
										</v-icon>
									</v-btn>							
								</template>
								<template v-slot:item.createdAt = "{ item }" >								
									{{ item.date }} 
								</template>
								<template v-slot:item.manager_id = "{ item }" >
									<v-chip 
										x-small
										:color = "!item.manager_id ? 'secondary' : 'success'"
									>
										<span>											
											{{ item.manager_id ? item.manager_id : $ml.get('data_no_found') }} 
										</span>
									</v-chip>
								</template>
								
							</v-data-table>
						</v-col>
					</v-row>
				</v-card-text>
			</v-card>
		</v-col>
	</v-row>
</template>
<script>
	import EventBus from '@/event-bus'
	export default{
		name : 'workspaces',
		data : (vm) => ({
			info 	: {},
			input 	: {},
			head 	: {
				title  : 'workstations',
				title1 : 'lpr',
				table  : 'registered_workspaces'
			}, 
			info_fields : [
				{
					key 	: "type",
					text   	: "type",
					type 	: "select",
					class   : "",				
					list 	: ["manager"],
					placeholder : vm.$ml.get("type"), 
					enable 		: true,
				},
				{
					key 	: "name",
					text   	: "name",
					type 	: "text",
					class   : "",				
					placeholder : vm.$ml.get("name"), 
					enable 		: true,
				},
				{
					key 	: "manager_id",
					text   	: "manager_id",
					type 	: "text",
					class   : "",				
					placeholder : vm.$ml.get("manager_id"), 
					enable 		: true,
				},
				{
					key 	: "computer",
					text   	: "computer",
					type 	: "text",
					class   : "",				
					placeholder : vm.$ml.get("computer"), 
					enable 		: true,
				},
				{
					key 	: "state",
					text   	: "state",
					type 	: "select",
					class   : "",	
					list 	: [ "active", "inactive"],			
					placeholder : vm.$ml.get("state"), 
					enable 		: true,
				},
				{
					key 	: "description",
					text   	: "description",
					type 	: "text",
					class   : "",				
					placeholder : vm.$ml.get("description"), 
					enable 		: true,
				},



			],
			show 		: {
			 	add_permissed_user 	: true,	
			 	add 				: false,
			 	add_workspace 		: true,
			 	edit_workspace 		: true,
			 	delete_workspace 	: true,
			},
			sub_title 	: vm.$ml.get('register'),
			
			show_progress : false,
			btn_action 	  : 'save',
			header_table  : [
				{ text: vm.$ml.get('manager'), value: 'manager_id', align: 'center' },
				{ text: vm.$ml.get('name'), value: 'name', align: 'center' },
				{ text: vm.$ml.get('description'), value: 'description', align: 'center' },
				{ text: vm.$ml.get('type'), value: 'type', align: 'center' },
				{ text: vm.$ml.get('state'), value: 'state', align: 'center' },

				{ text: vm.$ml.get('date'), 'value': 'createdAt', align: 'center'},
				{ text: vm.$ml.get('actions'), value: 'actions', align: 'center'}
			],
			options 	  : { itemsPerPage : 30 },
			total 		  : 0,
			layout_height : 400,
			ID_notification : 'workspaces',
			loading 	  : false,
			list_lists 	  : [],
			list 		  : [], 
			required_info : true,
			list_profiles : [],
			bus 		  : {},
			

		}), // data

		created(){
			
			/*let obj_new =  this.$Helper.set_property_obj(this.info_fields);
			if (obj_new) {
				this.info = obj_new;
			}*/
			let modul = this.$store.getters["auth/permission"](this.$route.name || "settings", "", "settings");
			if (modul) {
				if (!modul.can_add) { this.show.add_workspace = false }
				if (!modul.can_edit) { this.show.edit_workspace = false }
				if (!modul.can_delete ) { this.show.delete_workspace = false }
			}
		}, // created

		watch : {
			options : { 
				handler(){
					this.get_list();
				}, deep : true
			}, // options			
		
		}, // watch

		computed : {
			
			render_list : function(){
				return this.list;
			}, // render_list

		}, // computed

		methods : {
			actions(act, item, opt) {
				if (act == 'show') {
					this.show.add = !this.show.add;
					if (this.btn_action == 'update' || this.btn_action == 'save') {
						this.actions('clear_info');
					}
				}
				if ( act == 'clear_info') {
					this.btn_action = 'save';
					this.info 		= {};
					this.info_item  = {};
					this.sub_title 	= this.$ml.get('register');
					this.render_input('type_integrate');

				}
				if (act == 'save') {
					this.save();
				}
				if (act == 'update') {
					this.save(true);
				}
				if (act == 'edit') {
					this.info 		= { ...item };
					// this.info_item 	= this.list.indexOf(item);
					this.render_input('type_integrate');

					this.show.add	= true;
					this.sub_title 	= this.$ml.get('update');
					this.btn_action = 'update';
					this.info_item  = item;

				}
				if ( act == 'confirm_delete') {
					this.info_item = { ...item };

					EventBus.$emit('notifications_modal',{
						type  : 'confirm_delete',
						ID 	  : this.ID_notification,
					});
				}
			}, // actions

			render_listeds(list){
				if (this[list]) {
					return this[list];
				}else{
					return list;
				}

			}, // render_list

			get_list(){
				const { itemsPerPage, page } = this.options;
				const api 	 = this.$URL + '/api/v1/workspace/?page=' + page;
				this.loading = true;
				
				this.$axios.get(api).then( res => {
					console.log(res, 'res get_list');
					let items = res.data.rows;
					if (items && items.length > 0) {
						items.forEach((list_item) =>{
							if (list_item) {
								list_item = this.format_info(list_item);
							}
						})
					}
					this.total 	 = res.data.count;
					this.list  	 = [ ...items];
					this.loading = false;

				}).catch( er => {
					this.loading = false;					
					console.log(er, 'Error get_list');
					let  err = er && er.message ? er.message : er;
						

					this.$EventBus.$emit('notifications_modal',{
							type  	: 'error',
							message :  err
						});
				})

			}, // get list
			
			get_listing(){
				
				// const { itemsPerPage, page } = this.options;
				let pg 		= 1;
				let vm 		= this;
				const api 	= this.$URL + '/api/v1/workspace/?page=' + pg;
				// this.loading = true;
				
				this.$axios.get(api).then( res => {
					console.log(res, 'res get_list');
					let items 	  = res.data.rows;
					// this.total = res.data.count;
					let temp_list = [];

					if (items && items.length > 0) {
						items.forEach((item_list) => {
							if (item_list && item_list.name && vm.head.title1 == item_list.type) {
								temp_list.push(item_list);
							}
						})
					}
					console.log(" LISTS : ", temp_list, items)
					if (temp_list && temp_list.length > 0) {

						this.list_lists  	= [ ...temp_list ];
						this.required_info 	= true;
					}else{
						this.$EventBus.$emit('notifications_modal', {
							type 	: 'warning',
							message : ' Required have list created : go to lists'
						})
					}
					// this.loading = false;

				}).catch( er => {
					// this.loading = false;					
					console.log(er, 'Error get_list');
					let err = er && er.message ? er.message : er;
					this.$EventBus.$emit('notifications_modal',{
						type 	: 'warning',
						message : 'Failed Get de lists : ' + err
					})
				})
			}, // get listing

			save(up){
				if (up) {
					if (!this.$store.getters["auth/permission"](this.$route.name || "settings", "can_edit", "settings")){
						this.$EventBus.$emit("notifications_modal",{
							type 	: "warning",
							message : this.$ml.get("no_have_permission_edit") + " : " + this.$ml.get("settings"),
						});
						return false;
					};
				}else{
					if (!this.$store.getters["auth/permission"](this.$route.name || "settings", "can_add", "settings")){
						this.$EventBus.$emit("notifications_modal",{
							type 	: "warning",
							message : this.$ml.get("no_have_permission_create") + " : " + this.$ml.get("settings"),
						});
						return false;
					};
				}

				let opt 	= 'post';
				let info_up = { ...this.info };
				let api 	= this.$URL + '/api/v1/workspace';
				let check  	= false;
				let msg 	= ''; 

				this.loading = true;

				if (up) {
					opt = 'put';					
					msg = 'Not found id'
					if (info_up && info_up.id ) {
						api   += '/' + info_up.id;
						check  = true;
						msg    = '';
					}
				}else{
					check = true;
				}

				/*if (!info_up.listId) {
					check = false;
					msg   = this.$ml.get('require_sel_list')
				}*/
				if (check) {
					this.$axios[opt](api, info_up).then( res => {
						console.log('res ', opt, 'workspace', res );
						this.$EventBus.$emit('notifications_modal',{
							type : up ? 'updated' : 'saved', 
						});
						this.loading = false;
						// this.$router.back();
						if (!up) { // save
							this.total ++;
							let info_res = this.format_info(res.data);
							this.list.push(info_res);
						}else{
							let idx = this.list.indexOf(this.info_item);
							// console.log("update list : ", idx)
							// this.info_item = info_up;
							if (idx >= 0) {
								this.list.splice(idx, 1, info_up);
							}
						}
			    		this.info_fields[2].enable 	= false;

						if (this.show.add) {
							this.actions('show');
						}
					}).catch(er => {
						this.loading = false;						
						console.log("Error list setting ", opt, er);
						let  err 	 = up ? 'update ' : 'save ';
						err 	 	+= er && er.message ? er.message : er;

						this.$EventBus.$emit('notifications_modal',{
							type  	: 'error',
							message :  err
						});

					})

				}else{
					this.$EventBus.$emit('notifications_modal',{
						type  	: 'error',
						message :  msg
					});
					this.loading = false;

				}
			}, // save

			del(item){
				if (!this.$store.getters["auth/permission"](this.$route.name || "settings", "can_delete", "settings")){
					this.$EventBus.$emit("notifications_modal",{
						type 	: "warning",
						message : this.$ml.get("no_have_permission_delete") + " : " + this.$ml.get("settings"),
					});
					return false;
				};
				if (item) {
					let idx = this.list.indexOf(item);
					if (item.id) {
						this.loading = true;
						const api 	 = this.$URL + '/api/v1/workspace/' + item.id;
						this.$axios.delete(api).then(res =>{
							this.$EventBus.$emit('notifications_modal',{
								type : 'deleted', 							
							});
							this.list.splice(idx, 1);
							if (this.list && this.list.length === 0) {
								this.total = 0;
							}else{
								this.total = this.list && this.list.length == 1 ? 1 : this.list.length - 1;
							}
							this.loading   = false;							
							if (this.show.add) {
								this.actions('show');
							}
						}).catch( er => {
							console.log( "Error deleting ", er);
							this.loading = false;
							let  err 	 = up ? 'update ' : 'save ';
							err 		+= er && er.message ? er.message : er;
							this.$EventBus.$emit('notifications_modal',{
								type  	: 'error',
								message :  'Deleting item ' + err
							});
						})
					}else{
						this.$EventBus.$emit('notifications_modal',{
							type  	: 'warning',
							message :  'Item to delete have id'
						});	
					}
				}else{
					this.$EventBus.$emit('notifications_modal',{
						type  	: 'warning',
						message :  'Item to delete null'
					});
				}
			}, // del item

			format_info(item){
				if (item){
					if (item.listId) {
						let temp_lists = this.list_lists[this.list_lists.findIndex( x => x.id == item.listId)] ;						
						item.list = temp_lists ? temp_lists.name : false;
						
					}		
					if (item.createdAt) {
						item.date  = this.$momentz(item.createdAt).format('ll, LTS');
					}
					return item;			
				}
				return null
			}, // format info

			render_input(key){
				if (key == 'type_integrate' && this.info[key]){
					console.log("key : ", key,this.info[key])
					if(this.info[key] == 'cloud'){
		    			this.info_fields[2].enable  = true;
		    			this.info_fields[4].enable 	= false;
			    		this.info_fields[5].enable 	= false;
			    	}
			    	else{
			    		this.info_fields[2].enable 	= false;

			    		if (this.info.manager_id) {
			    			delete this.info.manager_id;
			    		}
			    		if (this.info[key] == "guardian_cloud") {
			    			this.info_fields[4].enable 	= true;
			    			this.info_fields[5].enable 	= true;
			    		}else{
			    			this.info_fields[4].enable 	= false;
			    			this.info_fields[5].enable 	= false;
			    		}
			    		
			    	}
				}else{
					// this.info_fields[2].enable = false;
				}
			}

		}, // methods

		mounted(){
			let temp_bus = 'notifications_modal' + this.ID_notification; 
			EventBus.$on(temp_bus, this.bus[temp_bus] = (action) => {
				if (action) {
					this.del(this.info_item);
				}
			}); 
			temp_bus = 'keyboard_type' + this.ID_notification;
			EventBus.$on(temp_bus, this.bus[temp_bus] = (action) =>{
				if (action) {
					console.log("INPUT TYPE : ",action)
					if (action.setting ) {
						let { obj, key, type, func } =  action.setting;
						if ( action.input || action.input == "") {

							if (type == 'text') {
								if (func == 'toUpperCase') {
									this[key] = action.input[func]();

								}else{
									this[key] = action.input;
								}
							}else{
								// console.log("obj key ", this[obj][key], action.input)
								this[obj][key] = action.input;
								
							}
						}
						 
					}
				}
			});
			temp_bus = 'keyboard_type_button' + this.ID_notification;
			EventBus.$on( temp_bus, this.bus[temp_bus] = (action) =>{
				if (action) {
					if (action.setting ) {
						let { obj, key, type, func } =  action.setting;
						console.log("SEARCH EVENT 1", action.button == "{enter}", type, key)

						if (action.button == '{enter}') {
							if (type == 'text' && key == 'search') {
								console.log("SEARCH EVENT")
								// this.get_search(this.search);
							}

						}
					}
				}
			})
		}, // mounted

		beforeDestroy(){
			this.$Helper.clear_bus(EventBus, this.bus, 'integration_cloud');

		}, // beforeDestroy

	}; // export default
</script>